import { useParams } from "react-router-dom";
import { PageHeader } from "@/components/site/PageHeader";

const CONTENT = {
  privacy: {
    title: "PRIVACY POLICY",
    label: "Legal",
    paras: [
      "This is a placeholder Privacy Policy for The Fish House Project. It will be replaced with a full policy before launch.",
      "When you join the community or send a message, we collect the information you provide (such as your name and email address) solely to keep you updated about the project and respond to your enquiries.",
      "We do not sell your data. You can ask to be removed from the mailing list at any time by getting in touch via the Contact page.",
    ],
  },
  cookies: {
    title: "COOKIE POLICY",
    label: "Legal",
    paras: [
      "This is a placeholder Cookie Policy for The Fish House Project. It will be replaced with a full policy before launch.",
      "The site may use essential cookies to function correctly and, in future, analytics cookies to understand how visitors use the site so it can be improved.",
      "You can control cookies through your browser settings.",
    ],
  },
  terms: {
    title: "TERMS",
    label: "Legal",
    paras: [
      "These are placeholder Terms for The Fish House Project. They will be replaced with full terms before launch.",
      "All content on this site is shared as part of an ongoing, personal project. Nothing here constitutes a guarantee of results, revenue or business outcomes.",
      "Future features such as the Fish House Test Lab, community giveaways and any commerce will have their own specific terms when they launch.",
    ],
  },
};

export default function Legal() {
  const { type } = useParams();
  const data = CONTENT[type] || CONTENT.privacy;

  return (
    <>
      <PageHeader label={data.label} title={data.title} />
      <section className="pb-28" data-testid="legal-page">
        <div className="max-w-3xl mx-auto px-5 lg:px-8 space-y-6">
          {data.paras.map((p, i) => (
            <p key={i} className="text-brand-textSec leading-relaxed">{p}</p>
          ))}
          <p className="text-brand-textMuted text-sm pt-4">Last updated: placeholder. This document is a work in progress.</p>
        </div>
      </section>
    </>
  );
}
